import Vue from "vue";

const state = {
  pageModal: {
    show: false,
    type: '',
    title: '',
    content: ''
  },
};

const actions = {
  setPageModal({commit}, modal) {
    commit('SET_PAGE_MODAL', modal)
  },
  clearPageModal({commit}) {
    commit('CLEAR_PAGE_MODAL')
  },
};

const mutations = {
  SET_PAGE_MODAL(state, modal) {
    Vue.set(state, 'pageModal', modal)
  },
  CLEAR_PAGE_MODAL(state) {
    Vue.set(state, 'pageModal', {
      show: false,
      type: '',
      title: '',
      content: ''
    })
  },
};

export default {
  state,
  actions,
  mutations
}
